import { ModalOverlay, ModalT1 } from "../../../../components/organisms/Modal";
import { PortalHeader } from "../../../../components/molecules/Header";
import { PortalFooter } from "../../../../components/molecules/Footer";
import { createPortal } from "react-dom";
import { StyledModalContent } from "../../../../components/organisms/Modal/Modal.styles";

const rootModals = document.getElementById("root-modals");

export function StockReplenishmentModal({ isLoading, handleApply, closeModal, description }) {
  if (!rootModals) return null;

  const modalContent = (
    <ModalOverlay aria-modal="true" role="dialog" aria-labelledby="stock-replenishment-title">
      <ModalT1 $minWidth={480} $maxWidth={600}>
        <PortalHeader title="Stock Replenishment" onClose={closeModal} />

        <StyledModalContent>{description}</StyledModalContent>

        <PortalFooter
          isDisabled={isLoading}
          onApply={handleApply}
          onCancel={closeModal}
          applyTitle="Generate"
          isLoading={isLoading}
        />
      </ModalT1>
    </ModalOverlay>
  );

  return createPortal(modalContent, rootModals);
}
